export const skillsList = [
  'frontend development',
  'backend development',
  'full stack development',
  'angular 1+',
  'angular 2+',
  'react',
  'vueJS',
  'typescript',
  'javascript',
  'express',
  'nodeJS',
  'deno',
  'design',
  'hybrid applications',
  'Progressive Web Applications',
  'develop',
  'automated testing',
  'cypress',
  'nightwatch',
  'docker',
  'selenium',
  'gatsby',
  'webrtc',
  'video conferencing',
  'voice engineering',
  'sip based communications',
  'asterisk',
  'open source'
]
